// extracted by mini-css-extract-plugin
module.exports = {"internalLink":"link_internalLink__1qCIZ","title":"link_title__YtqOC","deepLinkingClass":"link_deepLinkingClass__54Do6"};